import * as React from 'react';
import { Card } from '@mui/material';
import { styled } from '@mui/system';
import ImageUpload from './components/ImageUpload';
import NoteEditSection from './components/NoteEditSection/NoteEditSection';
import { useFormik } from 'formik';
import { noteSchema } from '../../schemas/note.request';
import { Navigate, generatePath } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import { AppContext } from '../../context/ContextProvider';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/auth/authSlice';
import { useCreateNoteMutation } from '../../store/api/noteApi';

const NoteCreateContainer = styled(Card)(({ theme }) => ({
  maxWidth: '827px',
  minHeight: '610px',
  border: '1px solid #ffff',
  background:
    'linear-gradient(250.42deg, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0.08) 101.65%)',
  padding: '12px 28px 12px 12px',
  margin: '50px auto 25px',
  [theme.breakpoints.down('md')]: {
    padding: '16px 25px 24px 25px',
  },
  [theme.breakpoints.down('sm')]: {
    border: 'none',
    background: 'none',
    padding: '0',
    boxShadow: 'none',
  },
}));

const NoteCreateForm = styled('form')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const validate = (values) => {
  const errors = {};
  const valid = noteSchema.validate(values, { abortEarly: false });
  if (valid.error) {
    valid.error.details.forEach((err) => {
      errors[err.path.join('.')] = err.message;
    });
  }
  return errors;
};

export default function NoteCreatePage() {
  const author = useSelector(selectUser);

  const [createPost, { data: newNote, isSuccess }] = useCreateNoteMutation();

  const { isShow, setIsShow, isLogin } = useContext(AppContext);
  useEffect(() => {
    if (!isLogin) {
      setIsShow(false);
    }
  }, [isLogin, isShow]);

  const formik = useFormik({
    initialValues: {
      title: '',
      content: '',
      category: '',
      relatedCafes: [],
      attachmentData: [],
    },
    validate,
    onSubmit: async (values) => {
      const { title, content, category, relatedCafes, attachmentData } = values;
      await createPost({ author, title, content, category, relatedCafes, attachmentData });
    },
  });

  if (isSuccess) {
    const newNoteId = newNote.data._id;
    return <Navigate to={generatePath('/note/:id', { id: newNoteId })} replace />;
  }

  return isLogin ? (
    <NoteCreateContainer>
      <NoteCreateForm onSubmit={formik.handleSubmit}>
        <ImageUpload formik={formik} />
        <NoteEditSection formik={formik} />
      </NoteCreateForm>
    </NoteCreateContainer>
  ) : (
    <Navigate to="/signin" />
  );
}
